import { render, staticRenderFns } from "./lff.vue?vue&type=template&id=0d5c4f3c&scoped=true&"
import script from "./lff.vue?vue&type=script&lang=js&"
export * from "./lff.vue?vue&type=script&lang=js&"
import style0 from "./lff.vue?vue&type=style&index=0&id=0d5c4f3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5c4f3c",
  null
  
)

export default component.exports